<template>
   <el-tabs type="border-card">
    <el-tab-pane label="合同列表">
      <div style="margin-top:16px;" >
        <el-form :inline="true" :model="contractForm" class="demo-form-inline">
          <el-form-item label="合同编号">
            <el-input size="mini" v-model.trim="contractForm.contractNo" placeholder="合同编号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="onSubmit" icon="el-icon-search">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <div style="margin-top:10px;">
        <el-table
        size="small"
          :data="data"
          border>
          <el-table-column
            prop="id"
            label="ID编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="contractNo"
            show-overflow-tooltip
            label="合同编号">
          </el-table-column>
          <el-table-column
            prop="contractUrl"
            show-overflow-tooltip
            label="合同链接">
          </el-table-column>
          <el-table-column
            prop="systemUserName"
            show-overflow-tooltip
            label="合同所属">
          </el-table-column>
          <el-table-column
            width="240"
            prop="createDate"
            label="创建时间">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="220">
            <template slot-scope="scope">
              <el-link  type="primary" :href="scope.row.contractUrl" target="_blank">预览</el-link>
              <el-popconfirm
                @confirm="handleDelete(scope.row, scope.$index)"
                title="确定删除这条记录吗？">
                <el-button slot="reference"
                type="danger"
                size="mini">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../../common/util/pagination";
export default {
  data() {
    return {
      data: [],
      serverUrl: "https://admin.ruidan.com/api/contract/offline/create", // 这里写你要上传的图片服务器地址
        // serverUrl: "http://127.0.0.1:7006/contract/offline/create",
      contractForm: {
        contractNo: '',
        token: this.user.getToken()
      },
      myHeaders: {Authorization: this.user.getToken()},
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      }
    };
  },
  components: {
    pagination
  },
  mounted: function() {
    this.getContractList()
  },
  methods: {
    getContractList: function() {
      this.optionItem = this.common.extend(this.contractForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/contract/offline/list', 
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    onSubmit: function() {
      this.getContractList()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getContractList()
    },
    handleDelete: function(row, index) {
      this.http.post(
        '/contract/offline/delete', 
        {id: row.id, token: this.common.getToken()}, res => {
          if (res.success) {
            // 返回正确的处理
            this.data.splice(index, 1);
          } else {
            // 返回错误的处理
            this.$message.error('删除失败请联系管理员！')
          }
      });
    }
  }
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// src/components/views/order/offline/contractList.vue